import axios from 'axios';

export interface LoginParams {
  username: string;
  password: string;
}

export interface LoginResponse {
  is2faEnabled?: boolean;
  otpToken?: string;
  token?: string;
}

export interface TwoFactorAuthParams {
  otp: string;
  otpToken: string;
}

export interface TwoFactorSettingsState {
  is2faEnabled: boolean;
  hasSecret: boolean;
}

export interface TwoFactorSettingsResponse {
  qrId: string;
  secret: string;
  otpToken: string;
}

export interface EnableTwoFactorParams {
  otp: string;
  otpToken: string;
}

export interface DisableTwoFactorParams {
  otp: string;
}

export class AuthApi {
  static async logIn(params: LoginParams): Promise<LoginResponse> {
    const { data } = await axios.post('/api/v1/login', params);

    return data;
  }

  static async twoFactorAuth(params: TwoFactorAuthParams): Promise<any> {
    const { data } = await axios.post('/api/v1/2fa/auth', params);

    return data;
  }

  static async getTwoFactorSettingsState(): Promise<TwoFactorSettingsState> {
    const { data } = await axios.get('/api/v1/2fa/settings/state');

    return data.data;
  }

  static async enableTwoFactorSettings(): Promise<TwoFactorSettingsResponse> {
    const { data } = await axios.post('/api/v1/2fa/settings');

    return data.data;
  }

  static async confirmEnableTwoFactor(params: EnableTwoFactorParams): Promise<any> {
    const { data } = await axios.patch('/api/v1/2fa/settings/enable', params);

    return data;
  }

  static async disableTwoFactor(params: DisableTwoFactorParams): Promise<any> {
    const { data } = await axios.patch('/api/v1/2fa/settings/disable', params);

    return data;
  }

  static getQRCodeImageUrl(qrId: string): string {
    return `/api/v1/image/${qrId}`;
  }

  static async logOut(): Promise<any> {
    const { data } = await axios.post('/api/v1/logout');

    return data;
  }
}
